import {
  CONTENT_CHILDS,
  CONTENT_IMAGE,
  CONTENT_MULTIPLE_IMAGE,
  CONTENT_SINGLE_TEXT,
  CONTENT_TARGET,
  CONTENT_TEXT,
  CONTENT_SNIPPET,
  CONTENT_CHECKBOX,
} from './arkulpa-fec/components/Content/contentConstants';
import config from './config';

const defaultType = [{title: 'Artikel', key: 'article', type: CONTENT_TEXT}];

const ImageLink = [
  {title: 'Url', key: 'url', type: CONTENT_SINGLE_TEXT},
  {title: 'Target', key: 'target', type: CONTENT_TARGET},
  {title: 'Titel', key: 'title', type: CONTENT_SINGLE_TEXT},
  {title: 'Image', key: 'image', type: CONTENT_IMAGE},
];

const TextSlider = [
  {title: 'Text', key: 'text', type: CONTENT_TEXT},
  {title: 'Image', key: 'media', type: CONTENT_IMAGE},
];

const contentDefinitions = {
  'arkulpa-next-js': {
    default: defaultType,
  },
  'stanztech-next-js': {
    default: [
      {title: 'Artikel', key: 'article', type: CONTENT_TEXT},
      {title: 'Header Image', key: 'headerImage', type: CONTENT_IMAGE},
      {title: 'Side Images', key: 'sideImages', type: CONTENT_MULTIPLE_IMAGE},
    ],
    index: [
      {title: 'Artikel', key: 'article', type: CONTENT_TEXT},
      {title: 'Header Image', key: 'headerImage', type: CONTENT_IMAGE},
      {title: 'Sliderimages', key: 'sliderImages', type: CONTENT_MULTIPLE_IMAGE},
      {
        title: 'Services',
        key: 'services',
        type: CONTENT_CHILDS,
        config: [
          {title: 'Name', key: 'name', type: CONTENT_SINGLE_TEXT},
          {title: 'Url', key: 'url', type: CONTENT_SINGLE_TEXT},
          {title: 'Image', key: 'image', type: CONTENT_IMAGE},
        ],
      },
    ],
    services: [
      {title: 'Header Image', key: 'headerImage', type: CONTENT_IMAGE},
      {
        title: 'Leistungen',
        key: 'services',
        type: CONTENT_CHILDS,
        config: [
          {title: 'Headline', key: 'title', type: CONTENT_SINGLE_TEXT},
          {title: 'Article', key: 'article', type: CONTENT_TEXT},
          {title: 'Image', key: 'image', type: CONTENT_IMAGE},
        ],
      },
    ],
  },
  'camp-v-next-js': {
    default: defaultType,
    index: [
      {title: 'Logo', key: 'logo', type: CONTENT_IMAGE},
      {title: 'Artikel', key: 'article', type: CONTENT_TEXT},
      {title: 'Slider', key: 'slider', type: CONTENT_MULTIPLE_IMAGE},
    ],
  },
  'worker-conf-next-js': {
    default: defaultType,
    index: [
      {title: 'Artikel', key: 'article', type: CONTENT_TEXT},
      {
        title: 'Speaker',
        key: 'speaker',
        type: CONTENT_CHILDS,
        config: [
          {title: 'Name', key: 'name', type: CONTENT_SINGLE_TEXT},
          {title: 'Project', key: 'project', type: CONTENT_SINGLE_TEXT},
          {title: 'Company', key: 'company', type: CONTENT_SINGLE_TEXT},
          {title: 'Twitter', key: 'twitter', type: CONTENT_SINGLE_TEXT},
          {title: 'Image', key: 'image', type: CONTENT_IMAGE},
        ],
      },
      {
        title: 'Slider',
        key: 'slider',
        type: CONTENT_CHILDS,
        config: TextSlider,
      },
      {
        title: 'Main Sponsors',
        key: 'mainSponsors',
        type: CONTENT_CHILDS,
        config: ImageLink,
      },
      {
        title: 'Sponsors',
        key: 'sponsors',
        type: CONTENT_CHILDS,
        config: ImageLink,
      },
      {
        title: 'Partners',
        key: 'partners',
        type: CONTENT_CHILDS,
        config: ImageLink,
      },
    ],
    content: [
      {title: 'Artikel', key: 'article', type: CONTENT_TEXT},
      {title: 'Slider', key: 'slider', type: CONTENT_MULTIPLE_IMAGE},
    ],
    team: [
      {
        title: 'Curators',
        key: 'curators',
        type: CONTENT_CHILDS,
        config: [
          {title: 'Name', key: 'name', type: CONTENT_SINGLE_TEXT},
          {title: 'Content', key: 'content', type: CONTENT_TEXT},
          {title: 'Twitter', key: 'twitter', type: CONTENT_SINGLE_TEXT},
          {title: 'Image', key: 'image', type: CONTENT_IMAGE},
        ],
      },
      {
        title: 'Hosts',
        key: 'hosts',
        type: CONTENT_CHILDS,
        config: [
          {title: 'Name', key: 'name', type: CONTENT_SINGLE_TEXT},
          {title: 'Content', key: 'content', type: CONTENT_TEXT},
          {title: 'Twitter', key: 'twitter', type: CONTENT_SINGLE_TEXT},
          {title: 'Image', key: 'image', type: CONTENT_IMAGE},
        ],
      },
    ],
  },
  'hampp-immo-nextjs': {
    index: [
      {title: 'Beschreibung', key: 'description', type: CONTENT_SINGLE_TEXT},
      {title: 'Titelbild', key: 'titleimage', type: CONTENT_IMAGE},
      {title: 'Banner', key: 'banners', type: CONTENT_SNIPPET, snippetType: 'banner'},
    ],
    default: [
      {title: 'Beschreibung', key: 'description', type: CONTENT_SINGLE_TEXT},
      {title: 'Titelbild', key: 'titleimage', type: CONTENT_IMAGE},
      {title: 'Artikel', key: 'article', type: CONTENT_TEXT},
    ],
    agent: [
      {title: 'Beschreibung', key: 'description', type: CONTENT_SINGLE_TEXT},
      {title: 'Titelbild', key: 'titleimage', type: CONTENT_IMAGE},
      {title: 'Kontakt', key: 'agents', type: CONTENT_SNIPPET, snippetType: 'agent'},
    ],
    award: [
      {title: 'Beschreibung', key: 'description', type: CONTENT_SINGLE_TEXT},
      {title: 'Titelbild', key: 'titleimage', type: CONTENT_IMAGE},
      {
        title: 'Auszeichnungen',
        key: 'awards',
        type: CONTENT_CHILDS,
        config: [
          {title: 'Titel', key: 'title', type: CONTENT_SINGLE_TEXT},
          {title: 'Beschreibung', key: 'description', type: CONTENT_TEXT},
          {title: 'Bild', key: 'image', type: CONTENT_IMAGE},
        ],
      },
    ],
    contact: [
      {title: 'Beschreibung', key: 'description', type: CONTENT_SINGLE_TEXT},
      {title: 'Titelbild', key: 'titleimage', type: CONTENT_IMAGE},
      {title: 'Firmenname', key: 'companyname', type: CONTENT_SINGLE_TEXT},
      {title: 'Adresszeile 1', key: 'addressline1', type: CONTENT_SINGLE_TEXT},
      {title: 'Adresszeile 2', key: 'addressline2', type: CONTENT_SINGLE_TEXT},
      {title: 'Telefon', key: 'tel', type: CONTENT_SINGLE_TEXT},
      {title: 'Fax', key: 'fax', type: CONTENT_SINGLE_TEXT},
      {title: 'Email', key: 'email', type: CONTENT_SINGLE_TEXT},
      {title: 'Web', key: 'web', type: CONTENT_SINGLE_TEXT},
    ],
    property: [
      {title: 'Referenzen', key: 'sold', type: CONTENT_CHECKBOX},
      {
        title: 'Beschreibung',
        key: 'description',
        type: CONTENT_TEXT,
      },
      {title: 'Ort', key: 'place', type: CONTENT_SINGLE_TEXT},
      {title: 'Titelbild', key: 'titleimage', type: CONTENT_IMAGE},
      {
        title: 'Bilder',
        key: 'images',
        type: CONTENT_MULTIPLE_IMAGE,
      },
      {title: 'Badges', key: 'badges', type: CONTENT_SNIPPET, snippetType: 'badge'},
      {
        title: 'Eigenschaften',
        key: 'features',
        defaultValues: [
          {label: 'Ort', key: 'place', description: ''},
          {label: 'Preis', key: 'price', description: ''},
          {label: 'Fläche', key: 'space', description: ''},
          {label: 'Baujahr', key: 'year', description: ''},
          {label: 'Beschreibung', key: 'description', description: ''},
          {label: 'Nebenkosten', key: 'costs', description: ''},
          {label: 'Sonstiges', key: 'other', description: ''},
          {label: 'Provision', key: 'provision', description: ''},
        ],
        type: CONTENT_CHILDS,
        config: [
          {title: 'Beschriftung', key: 'label', type: CONTENT_SINGLE_TEXT},
          {title: 'Beschreibung', key: 'description', type: CONTENT_TEXT},
        ],
      },
      {
        title: 'Heizung',
        key: 'heating',
        type: CONTENT_CHILDS,
        defaultValues: [
          {label: 'Art der Heizung', key: 'type', description: ''},
          {label: 'Energieausweistyp', key: 'energyPass', description: ''},
          {label: 'Kennwert', key: 'specificValue', description: ''},
          {label: 'Baujahr Anlagentechnik', key: 'yearInstallation', description: ''},
          {label: 'Energieeffizienzklasse', key: 'class', description: ''},
        ],
        config: [
          {title: 'Beschriftung', key: 'label', type: CONTENT_SINGLE_TEXT},
          {title: 'Beschreibung', key: 'description', type: CONTENT_TEXT},
        ],
      },
      {title: 'Kontakt', key: 'contact', type: CONTENT_SNIPPET, snippetType: 'agent'},
    ],
  },
};

const slugPrefix = {
  'hampp-immo-nextjs': {
    property: 'objekt',
  },
};

export const getSlugPrefix = (project, type) => {
  if (slugPrefix[project] && slugPrefix[project][type]) {
    return slugPrefix[project][type];
  }
  return null;
};

export const getContentTypes = () => {
  const project = config.getProjectKey();
  if (!contentDefinitions[project]) {
    return [];
  } else {
    return Object.keys(contentDefinitions[project]);
  }
};

export const getContentDefinition = (project, type) => {
  if (!contentDefinitions[project]) {
    return defaultType;
  }
  const ws = contentDefinitions[project];
  if (!ws[type]) {
    return defaultType;
  }
  return ws[type];
};



// WEBPACK FOOTER //
// ./src/contentDefinitions.js